// src/admin/utils/csv.ts — client-side CSV from rows of objects.
// Uses RFC 4180 quoting rules and BOM so Excel opens UTF-8 correctly.

export function rowsToCsv<T extends Record<string, unknown>>(
  rows: T[],
  columns: { key: keyof T; header: string; format?: (v: T[keyof T], row: T) => string }[],
): string {
  const header = columns.map(c => escape(c.header)).join(',');
  const body = rows.map(r => columns.map(c => {
    const raw = c.format ? c.format(r[c.key], r) : r[c.key];
    return escape(raw == null ? '' : String(raw));
  }).join(',')).join('\r\n');
  return `\ufeff${header}\r\n${body}\r\n`;
}

function escape(v: string): string {
  if (/[",\r\n]/.test(v)) {
    return `"${v.replace(/"/g, '""')}"`;
  }
  return v;
}

export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
